<app-chat-card
  class="coming-soon-card"
  [header]="'Smart AI to Do More! (Coming Soon)'"
  [description]="
    'Let AI agents create presentations, design PDFs, and connect to apps for you. Next-level learning is near!'
  "
  [route]="'/agents'"
>
</app-chat-card>
